import React from "react";
import PageIntro from "../components/PageIntro";
import cashlessData from "../content/Cashles_Payments.json";

const CashlessPayments = () => {
  return (
    <>
      <PageIntro
        title={cashlessData.title}
        subtitle=""
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6"
      ></PageIntro>
      <section className="bg-ofWhite overflow-hidden pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="">
            <h1 className="text-2xl font-bold mb-2">{cashlessData.title}</h1>
            {cashlessData.subtitle && (
              <h2 className="text-xl mb-4">{cashlessData.subtitle}</h2>
            )}

            {cashlessData.sections.map((section, index) => (
              <div key={index} className="mb-6">
                {section.heading && (
                  <h3 className="text-lg font-semibold mb-2">
                    {section.heading}
                  </h3>
                )}

                {section.content.map((text, i) => (
                  <p key={i} className="mb-1">
                    {text}
                  </p>
                ))}

                {section.list && (
                  <ul className="list-disc list-inside mt-2">
                    {section.list.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CashlessPayments;
